import { createAsyncThunk } from "@reduxjs/toolkit";
import coursesService from "../../../api/services/courses";

export const getCourses = createAsyncThunk("courses/getCourses", async (params) => {
  return await coursesService.getCourses(params);
});

export const getCourseById = createAsyncThunk("courses/getCourseById", async (id) => {
  return await coursesService.getCourseById(id);
});

export const getFeaturedCourses = createAsyncThunk("courses/getFeaturedCourses", async (limit) => {
  return await coursesService.getFeaturedCourses(limit);
});

export const getUserCourses = createAsyncThunk("courses/getUserCourses", async () => {
  return await coursesService.getUserCourses();
});
